import BaseApi from './baseApi';
import IAuthentication from '../models/IAuthentication';
import ICompanyExciseTariffLine from '../models/ICompanyExciseTariffLine';

export default class CompanyExciseTariffLinesApi extends BaseApi {
    idUser: string = "";

    constructor() {
        super("dataaccess", "Goods");
        let userFromStorage: IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetCompanyExciseTariffLines(): Promise<ICompanyExciseTariffLine[]> {
        let json: string = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            let tariffLines: ICompanyExciseTariffLine[] = [];
            tariffLines = response.data as ICompanyExciseTariffLine[];
            return tariffLines;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetCompanyExciseTariffLinesByTariffSet(idTariffSet: string): Promise<ICompanyExciseTariffLine[]> {
        let json: string = this.getJsonReadByTariffSet(idTariffSet);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            let tariffLines: ICompanyExciseTariffLine[] = [];
            tariffLines = response.data as ICompanyExciseTariffLine[];
            return tariffLines;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveCompanyExciseTariffLine(tariffLine: ICompanyExciseTariffLine): Promise<string> {
        const json = this.getJsonSave(tariffLine);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateCompanyExciseTariffLine(tariffLine: ICompanyExciseTariffLine): Promise<boolean> {
        const json = this.getJsonUpdate(tariffLine);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteCompanyExciseTariffLine(id: string): Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string): any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "CompanyExciseTariffLines",
            "conditions": [{
                "Item1": "CompanyExciseTariffLines",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(tariffLine: ICompanyExciseTariffLine): any {
        const json = {
            "fieldsvalues": [{
                "Item1": "IdTariffSet",
                "Item2": tariffLine.idTariffSet
            }, {
                "Item1": "IdExciseDrinkCategory",
                "Item2": tariffLine.idExciseDrinkCategory
            }, {
                "Item1": "AlcoholFrom",
                "Item2": tariffLine.alcoholFrom
            }, {
                "Item1": "AlcoholTo",
                "Item2": tariffLine.alcoholTo
            }, {
                "Item1": "RateType",
                "Item2": tariffLine.rateType
            }, {
                "Item1": "RateAmount",
                "Item2": tariffLine.rateAmount
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "CompanyExciseTariffLines"
        };
        return json;
    }

    private getJsonUpdate(tariffLine: ICompanyExciseTariffLine): any {
        const json = {
            "fieldsvalues": [{
                "Item1": "IdTariffSet",
                "Item2": tariffLine.idTariffSet
            }, {
                "Item1": "IdExciseDrinkCategory",
                "Item2": tariffLine.idExciseDrinkCategory
            }, {
                "Item1": "AlcoholFrom",
                "Item2": tariffLine.alcoholFrom
            }, {
                "Item1": "AlcoholTo",
                "Item2": tariffLine.alcoholTo
            }, {
                "Item1": "RateType",
                "Item2": tariffLine.rateType
            }, {
                "Item1": "RateAmount",
                "Item2": tariffLine.rateAmount
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "CompanyExciseTariffLines",
            "keyvalue": tariffLine.id
        };
        return json;
    }

    private getJsonRead(): any {
        const json = {
            "fields": [{
                "Item1": "CompanyExciseTariffLines",
                "Item2": "id"
            }, {
                "Item1": "CompanyExciseTariffLines",
                "Item2": "IdTariffSet"
            }, {
                "Item1": "CompanyExciseTariffLines",
                "Item2": "IdExciseDrinkCategory"
            }, {
                "Item1": "ListExciseDrinkCategories",
                "Item2": "name as DrinkCategoryName"
            }, {
                "Item1": "CompanyExciseTariffLines",
                "Item2": "AlcoholFrom"
            }, {
                "Item1": "CompanyExciseTariffLines",
                "Item2": "AlcoholTo"
            }, {
                "Item1": "CompanyExciseTariffLines",
                "Item2": "RateType"
            }, {
                "Item1": "CompanyExciseTariffLines",
                "Item2": "RateAmount"
            }],
            "tables": [{
                "Item1": "CompanyExciseTariffLines"
            }, {
                "Item1": "ListExciseDrinkCategories"
            }],
            "joins": [{
                "Item1": "CompanyExciseTariffLines",
                "Item2": "IdExciseDrinkCategory",
                "Item3": "ListExciseDrinkCategories",
                "Item4": "id"
            }],
            "conditions": [{
                "Item1": "CompanyExciseTariffLines",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }],
            "orderBy": [{
                "Item1": "CompanyExciseTariffLines.IdExciseDrinkCategory"
            }, {
                "Item1": "CompanyExciseTariffLines.AlcoholFrom"
            }]
        };
        return json;
    }

    private getJsonReadByTariffSet(idTariffSet: string): any {
        const json = {
            "fields": [{
                "Item1": "CompanyExciseTariffLines",
                "Item2": "id"
            }, {
                "Item1": "CompanyExciseTariffLines",
                "Item2": "IdTariffSet"
            }, {
                "Item1": "CompanyExciseTariffLines",
                "Item2": "IdExciseDrinkCategory"
            }, {
                "Item1": "ListExciseDrinkCategories",
                "Item2": "name as DrinkCategoryName"
            }, {
                "Item1": "CompanyExciseTariffLines",
                "Item2": "AlcoholFrom"
            }, {
                "Item1": "CompanyExciseTariffLines",
                "Item2": "AlcoholTo"
            }, {
                "Item1": "CompanyExciseTariffLines",
                "Item2": "RateType"
            }, {
                "Item1": "CompanyExciseTariffLines",
                "Item2": "RateAmount"
            }],
            "tables": [{
                "Item1": "CompanyExciseTariffLines"
            }, {
                "Item1": "ListExciseDrinkCategories"
            }],
            "joins": [{
                "Item1": "CompanyExciseTariffLines",
                "Item2": "IdExciseDrinkCategory",
                "Item3": "ListExciseDrinkCategories",
                "Item4": "id"
            }],
            "conditions": [{
                "Item1": "CompanyExciseTariffLines",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "CompanyExciseTariffLines",
                "Item2": "IdTariffSet",
                "Item3": "=",
                "Item4": idTariffSet
            }],
            "orderBy": [{
                "Item1": "CompanyExciseTariffLines.IdExciseDrinkCategory"
            }, {
                "Item1": "CompanyExciseTariffLines.AlcoholFrom"
            }]
        };
        return json;
    }
}
